import React from 'react';
import { useTranslation } from 'react-i18next';

export const AccessDenied: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="panel-page">
      <h1 className="panel-page-title">{t('common.accessDenied')}</h1>
      <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
        {t('common.accessDeniedHint')}
      </p>
    </div>
  );
};
